import { h, Component } from 'preact';
import style from './style'
import {TimeSlot, I18n} from 'components/elements'

export default (props)=>{
    const dynamicHeight = props.showAll ? ((Math.ceil(props.timeSlots.length / 3) * 48) - 16) : 80;
    const thereAreTimeSlots = !!props.timeSlots.length;

	return (
        <div class={style.select} style={thereAreTimeSlots ? {height:dynamicHeight} : {}}>
            {props.timeSlots.length ?
                props.timeSlots.map((timeSlot, index) => {
                    return (
                        <TimeSlot 
                            {...timeSlot}
                            onSelect={props.onSelect}
                            selected={props.selectedTimeSlot.id == timeSlot.id}
                        />
                    )
                })
            : !props.isWidgetAvailableAfter ? (
                <div class={style.noAppointments}><I18n>noBookingThisFarOut</I18n></div>
            ):(
                <div class={style.noAppointments}><I18n>noAppointments</I18n></div>
            )}
        </div>
	)
}


// WEBPACK FOOTER //
// ./components/groups/TimeSlotColumn/index.js